import axios from "@/lib/axios";

export interface AssignedAgent {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  avatar?: string;
  bio?: string;
  company: string;
  licenseNumber: string;
  experience: number;
  specialties: string[];
  languages: string[];
  rating: number;
  reviewCount: number;
  commissionRate: number;
  isVerified: boolean;
  availability: {
    monday: { start: string; end: string; available: boolean };
    tuesday: { start: string; end: string; available: boolean };
    wednesday: { start: string; end: string; available: boolean };
    thursday: { start: string; end: string; available: boolean };
    friday: { start: string; end: string; available: boolean };
    saturday: { start: string; end: string; available: boolean };
    sunday: { start: string; end: string; available: boolean };
  };
}

export interface AgentAssignmentResponse {
  success: boolean;
  message: string;
  data?: {
    assignedAgent: AssignedAgent;
  };
}

export const agentAssignmentApi = {
  // Assign agent to customer
  assignAgent: async (): Promise<AgentAssignmentResponse> => {
    const response = await axios.post("/api/agent-assignment/assign");
    return response.data;
  },

  // Get assigned agent for customer
  getAssignedAgent: async (): Promise<{
    success: boolean;
    data: AssignedAgent;
  }> => {
    const response = await axios.get("/api/agent-assignment/assigned");
    return response.data;
  },

  // Reassign agent (admin only)
  reassignAgent: async (
    customerId: string,
    newAgentId: string
  ): Promise<AgentAssignmentResponse> => {
    const response = await axios.post("/api/agent-assignment/reassign", {
      customerId,
      newAgentId,
    });
    return response.data;
  },

  // Get agent's leads (agent only)
  getAgentLeads: async (): Promise<{
    success: boolean;
    data: { leads: any[]; totalLeads: number };
  }> => {
    const response = await axios.get("/api/agent-assignment/leads");
    return response.data;
  },

  // Update lead status (agent only)
  updateLeadStatus: async (
    leadId: string,
    status: string,
    notes?: string
  ): Promise<{ success: boolean; data: any }> => {
    const response = await axios.put(
      `/api/agent-assignment/leads/${leadId}/status`,
      {
        status,
        notes,
      }
    );
    return response.data;
  },
};
